<div class="container">
    <img src="assets/imgs/404-page-bg.jpg" alt="" width="100%" />
    <div class="description">
        <p>Page Not Found</p>
        <div class="sub-title">Please go back to Home, or try again.</div>
        <button nz-button class="login-form-button login-form-margin" [nzType]="'primary'" (click)="goHome()">Home</button>
    </div>
</div>
